/**
 * Client-side personrole dedupe — mirrors dashboard/utils/dedupePersonRoles.js
 */

export function dedupePersonRoleDisplay(relations, organisations = {}, roles = {}) {
  if (!Array.isArray(relations) || !relations.length) return [];

  const mapped = relations.map((relation) => ({
    organisation: organisations[relation.org_id] || null,
    role: String(relation.other_role || "").trim()
      ? `Other - ${String(relation.other_role).trim()}`
      : roles[relation.role_id] || null,
    orgId: relation.org_id ? String(relation.org_id) : '',
    roleId: relation.role_id ? String(relation.role_id) : '',
  }));

  const seen = new Set();
  const out = [];

  for (const r of mapped) {
    const organisation = r.organisation || '';
    const role = r.role || '';
    if (!organisation && !role) continue;
    const key = `${organisation}|${role}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ organisation, role });
  }

  return out;
}

export function dedupeOrgNamesForPerson(relations, organisations = {}) {
  if (!Array.isArray(relations) || !relations.length) return [];

  const names = relations
    .map((r) => organisations[r.org_id])
    .filter(Boolean);

  return [...new Set(names)];
}

/** The organisation to show for a person: the one marked main, else the first. */
export function pickMainOrgName(relations, organisations = {}) {
  if (!Array.isArray(relations)) return '';
  const named = relations.filter((r) => organisations[r.org_id]);
  const main = named.find((r) => r.main_role) || named[0];
  return main ? organisations[main.org_id] : '';
}
